import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SopService } from "../../Shared/sop.service";
import { Constant } from "../../../Shared/Models/constant";
import { ToastrService } from "ngx-toastr";
import { BranchService } from "../../Shared/branch.service";
import { AuthService } from "../../../Shared/Auth/auth.service";
import { JobsService } from "../../Shared/jobs.service";
import { ModalDirective } from "ngx-bootstrap/modal";
import { NgxImageCompressService } from "ngx-image-compress";
import { CarouselConfig } from "ngx-bootstrap/carousel";
import { Lightbox } from "ngx-lightbox";
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
@Component({
    selector: "app-survey-link",
    templateUrl: "./survey-link.component.html",
    styleUrls: ["./survey-link.component.scss"],
    providers: [DatePipe],
})
export class SurveyLinkComponent implements OnInit, OnDestroy {
    private _album: Array<any> = [];
    capture: any;
    quillConfig = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],

            [{ 'size': ['small', 'medium', 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'font': [] }],
            [{ 'align': [] }]
        ]
    }
    submitted = false;
    productForm: FormGroup;
    isVideoActive = false;
    isSurveyChecklistRestricted = false;
    isDocChecklistRestricted = false;
    SOPName = "Image & Documents";
    EditActive = true;
    Add_image_field;
    Document_field;
    EditForm: any;
    id;
    constant: any;
    imageURL: any;
    /** Local preview URL for selected survey video (released in ngOnDestroy). */
    videoPreviewUrl: string | null = null;
    videoFileLabel = "";
    isAdmin = this.authService.isAllowedAccess("admin");

    /** Getter for video preview - returns the URL if set, null otherwise */
    get videoPreview(): string | null {
        return this.videoPreviewUrl;
    }
    FilterImageArray: Array<any> = [];
    LatLongData: any = null;
    ImageArray: Array<any> = [];
    @ViewChild("primaryModal") public primaryModal: ModalDirective;

    @ViewChild("Gallery") public Gallery: ModalDirective;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private SOPService: SopService,
        private router: Router,
        private toastr: ToastrService,
        private BranchService: BranchService,
        private authService: AuthService,
        private JobsService: JobsService,
        private imageCompress: NgxImageCompressService,
        private _lightbox: Lightbox,
        public datepipe: DatePipe
    ) {
        this.productForm = this.fb.group({
            form_field: this.fb.array([]),
            job_remark: [],
            video_file: "",
        });
    }

    ngOnInit(): void {
        this.constant = new Constant();
        this.isAdmin = this.authService.isAllowedAccess("admin");
        this.id = this.route.snapshot.paramMap.get("id");
        this.GetImageDocumentDetails(this.id);
        this.MenuSelectionManagement("NavItem2");
        // this.JobsService.JobDetail(this.id)
        // .subscribe(data => {
        //   let Jobeditdetail= data.result;
        //   this.GetImageDocumentDetails(Jobeditdetail['id']);
        // });
        // if(this.isAdmin){
        //   this.getBranchList();
        // }else{
        //   this.branchList = JSON.parse(localStorage.getItem('SubAdminBranch'));
        // }
    }
    files: any;
    options: any;

    newFormField(value = ""): FormGroup {
        return this.fb.group({
            form_field_label: [value, Validators.required],
        });
    }
    newDocumentField(value = "") {
        return this.fb.group({
            form_document_label: [value, Validators.required],
        });
    }
    addFormField(value = "", name = undefined, custom) {
        let newValue =
            value == "assets/img/no-image.jpg"
                ? ""
                : value.replace(/^[ ]+/g, "");
        if (custom) {
            var valueArr = this.ImageArray.map(function (item) {
                return item.form_field_label?.name
                    ? item.form_field_label.name.toUpperCase()
                    : "";
            });

            if (valueArr.length > 0) {
                var isDuplicateForm = valueArr.some(function (item, idx) {
                    return valueArr.indexOf(name.toUpperCase()) == -1;
                });
            }
        }
        this.formFieldArray().push(this.newFormField(newValue));
        this._album.push({
            src: value,
            caption: name ? name : this.Add_image_field.replace(/^[ ]+/g, ""),
            thumb: value,
        });
        this.ImageArray.push({
            form_field_label: {
                src: value,
                name: name ? name : this.Add_image_field.replace(/^[ ]+/g, ""),
                custom: custom,
            },
        });
        this.Add_image_field = "";
    }

    
    // Handle file selection from Add Image Field button
    onAddImageFieldChange(event: any) {
        console.log('onAddImageFieldChange called', event.target.files.length);
        
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const fileName = file.name;
            
            // Check if it's an image file
            if (file.type.startsWith('image/')) {
                // Create image preview and process upload
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    // Add form field with image preview
                    this.addFormField(e.target.result, fileName, true);
                    
                    // Get the index of the newly added item
                    const newIndex = this.formFieldArray().length - 1;
                    const newItem = this.formFieldArray().at(newIndex);
                    
                    // Process image compression and upload directly
                    let image: any = e.target.result;
                    let ratio = this.compressRatio(file.size / 1024);
                    let quality = file.size / 1000 > 400 ? 80 : 100;
                    
                    this.imageCompress
                        .compressFile(image, -1, ratio, quality)
                        .then((result) => {
                            this.constant.showLoader();
                            this.uploadImage(result, newItem, newIndex, 'form_field_label');
                        });
                };
                reader.readAsDataURL(file);
            } else {
                this.toastr.warning('Please select an image file');
                event.target.value = '';
            }
        }
        
        // Reset the file input
        event.target.value = '';
    }


    // Handle file selection from Add Document Field button
    onAddDocumentFieldChange(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const fileName = file.name;
            
            // Check if it's an image file
            if (file.type.startsWith('image/')) {
                // Create image preview and process upload
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    // Add document field with image preview
                    this.addDocumentField(e.target.result, fileName, true);
                    
                    // Get the index of the newly added item
                    const newIndex = this.formFieldArray().length - 1;
                    const newItem = this.formFieldArray().at(newIndex);
                    
                    // Process image compression and upload directly
                    let image: any = e.target.result;
                    let ratio = this.compressRatio(file.size / 1024);
                    let quality = file.size / 1000 > 400 ? 80 : 100;
                    
                    this.imageCompress
                        .compressFile(image, -1, ratio, quality)
                        .then((result) => {
                            this.constant.showLoader();
                            this.uploadImage(result, newItem, newIndex, 'form_document_label');
                        });
                };
                reader.readAsDataURL(file);
            } else {
                this.toastr.warning('Please select an image file');
                event.target.value = '';
            }
        }
        
        // Reset the file input
        event.target.value = '';
    }


    // Extracted image processing logic
    processImageUpload(event: any, index: number, section: string, item: any) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            let image: any = reader.result;
            
            let ratio = this.compressRatio(event.target.files[0].size / 1024);
            let quality = event.target.files[0].size / 1000 > 400 ? 80 : 100;
            
            this.imageCompress
                .compressFile(image, -1, ratio, quality)
                .then((result) => {
                    this.constant.showLoader();
                    this.uploadImage(result, item, index, section);
                });
        };
    }

    addDocumentField(value = "", name = undefined, custom) {

        let newValue =
            value == "assets/img/no-image.jpg"
                ? ""
                : value.replace(/^[ ]+/g, "");
        if (custom) {
            var valueArr = this.ImageArray.map(function (item) {
                return item.form_document_label?.name
                    ? item.form_document_label.name.toUpperCase()
                    : "";
            });
            var isDuplicateForm = valueArr.some(function (item, idx) {
                return valueArr.indexOf(name.toUpperCase()) == -1;
            });
        }
        this.formFieldArray().push(this.newDocumentField(newValue));
        this._album.push({
            src: value,
            caption: name ? name : this.Document_field.replace(/^[ ]+/g, ""),
            thumb: value,
        });
        this.ImageArray.push({
            form_document_label: {
                src: value,
                name: name ? name : this.Document_field.replace(/^[ ]+/g, ""),
                custom: custom,
            },
        });
        this.Document_field = "";
    }

    removeQuantity(i: number) {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this sop!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#5d87ff",
            cancelButtonColor: "#f64846",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                this.formFieldArray().removeAt(i);
                this._album.splice(i, i);
                this.ImageArray.splice(i, 1);
            }
        });
    }
    formFieldArray(): FormArray {
        return this.productForm.get("form_field") as FormArray;
    }

    /** True when slot has no real image yet (empty, or default no-image asset). */
    isPlaceholderSrc(src: string | undefined | null): boolean {
        if (src == null || String(src).trim() === "") {
            return true;
        }
        const s = String(src).toLowerCase();
        return s.indexOf("no-image") !== -1 || s.indexOf("no_image") !== -1;
    }

    private revokeVideoPreview(): void {
        if (this.videoPreviewUrl) {
            URL.revokeObjectURL(this.videoPreviewUrl);
            this.videoPreviewUrl = null;
        }
    }

    ngOnDestroy(): void {
        this.revokeVideoPreview();
    }

    onFileChange(event) {
        if (event.target.files.length > 0) {
            var vid = document.createElement("video");
            const file = event.target.files[0];
            this.videoFileLabel = file.name;
            var fileURL = URL.createObjectURL(event.target.files[0]);
            vid.src = fileURL;
            vid.preload = "metadata";
            vid.onloadedmetadata = () => {
                window.URL.revokeObjectURL(vid.src);
                if (vid.duration < 30) {
                    this.revokeVideoPreview();
                    this.videoPreviewUrl = URL.createObjectURL(file);
                    this.productForm.patchValue({
                        video_file: file,
                    });
                } else {
                    this.revokeVideoPreview();
                    this.videoFileLabel = "";
                    Swal.fire({
                        title: "Oops!",
                        icon: "error",
                        text: "Video duration should be less than 30 seconds",
                        showConfirmButton: true,
                    }).then(function () { });
                    event.target.value = "";
                }
            };
        }
    }

    removeVideo(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.revokeVideoPreview();
        this.videoFileLabel = "";
        this.productForm.patchValue({
            video_file: null,
        });
        const inputElement = document.getElementById('videoFileInput') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = '';
        }
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.formFieldArray().controls,
            event.previousIndex,
            event.currentIndex
        );
        moveItemInArray(
            this.formFieldArray().value,
            event.previousIndex,
            event.currentIndex
        );
    }
    showPreview(event) {
        console.log(event);
        const file = (event.target as HTMLInputElement).files[0];
        const reader = new FileReader();
        reader.onload = () => {
            this.imageURL = reader.result as string;
        };
        reader.readAsDataURL(file);
        this.primaryModal.show();
    }
    compressFile(index, section, item) {
        this.imageCompress.uploadFile().then(({ image, orientation }) => {
            let ImageSize = this.imageCompress.byteCount(image) / 1024;
            let quality =
                ImageSize > 400 ? this.getImageQuality(ImageSize) : 100;
            let ratio = this.compressRatio(ImageSize);
            this.imageCompress
                .compressFile(image, orientation, ratio, quality)
                .then((result) => {
                    this.constant.showLoader();
                    this.uploadImage(result, item, index, section);
                    console.warn(
                        "Size in bytes is now:",
                        this.imageCompress.byteCount(result)
                    );
                });
        });
    }
    uploadImage(result, item, index, section) {
        let file = {
            file: result,
            is_document: section == 'form_document_label' ? 1 : 0,
            upload_type: 'motor_survey_link',
            inspection_id: this.EditForm?.inspection_id
        };
        if (this.LatLongData) {
            file["location"] = {
                lat: this.LatLongData.coords.latitude,
                long: this.LatLongData.coords.longitude,
            };
        }
        this.JobsService.uploadJobDoc(file).subscribe(
            (data) => {
                this.constant.hideLoader();
                item.setValue(data.result.file_name);
                this.ImageArray[index][section].src =
                    data.result.path;
                this._album[index].src = data.result.path;
                this._album[index].caption = data.result.file_name;
                this._album[index].thumb = data.result.path;
            },
            (error) => {
                if (error.status == 401) {
                    console.log(error.message);
                    this.router.navigate(["/login"]);
                }
                this.constant.hideLoader();
            }
        );

    }
    getImageQuality(Size: any) {
        let size = 100;
        switch (true) {
            case 700 > Size && Size > 200:
                size = 100;
                break;
            case 800 > Size && Size > 700:
                size = 95;
                break;
            case 900 > Size && Size > 800:
                size = 90;
            case 1000 > Size && Size > 900:
                size = 85;
            case Size > 1000:
                size = 80;
        }
        return size;
    }
    fileChange(event, index, section, item) {
        console.log('fileChange called with:', { index, section, item, files: event.target.files.length });
        
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            
            // Process image file
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    let image: any = reader.result;

                    let ratio = this.compressRatio(file.size / 1024);
                    let quality = file.size / 1000 > 400 ? 80 : 100;
                    
                    this.imageCompress
                        .compressFile(image, -1, ratio, quality)
                        .then((result) => {
                            this.constant.showLoader();
                            this.uploadImage(result, item, index, section);

                            console.warn(
                                "Size in bytes is now:" +
                                this.imageCompress.byteCount(result) / 1000
                            );
                        });
                }.bind(this);
            } else {
                this.toastr.warning('Please select an image file');
                event.target.value = '';
            }
        }
    }

    Submit() {
        console.log(this.ImageArray);
        this.submitted = true;
        console.log(this.productForm.invalid);
        if (this.productForm.invalid) {
            return;
        } else {
            let formData = JSON.parse(JSON.stringify(this.productForm.value));
            formData.can_record_video = this.productForm.value.form_video_label
                ? 1
                : 0;

            formData.document_images_field_post = [];
            formData.vehichle_images_field_post = [];
            formData.custom_vehichle_images_field_post = [];
            formData.custom_document_images_field_post = [];

            this.ImageArray.map((val) => {
                if (val.form_field_label && !val.form_field_label.custom) {
                    var obj = {};
                    obj['name'] = val.form_field_label.name;
                    obj['path'] = val.form_field_label.src;
                    formData.vehichle_images_field_post.push(obj);
                } else if (
                    val.form_document_label &&
                    !val.form_document_label.custom
                ) {
                    var obj = {};
                    obj['name'] = val.form_document_label.name;
                    obj['path'] =
                        val.form_document_label.src;
                    formData.document_images_field_post.push(obj);
                } else if (
                    val.form_field_label &&
                    val.form_field_label.custom
                ) {
                    var obj = {};
                    obj['name'] = val.form_field_label.name;
                    obj['path'] = val.form_field_label.src;
                    formData.custom_vehichle_images_field_post.push(obj);
                } else if (
                    val.form_document_label &&
                    val.form_document_label.custom
                ) {
                    var obj = {};
                    obj['name'] = val.form_document_label.name;
                    obj['path'] =
                        val.form_document_label.src;
                    formData.custom_document_images_field_post.push(obj);
                }
            });

            if (
                formData.vehichle_images_field_post.length == 0 &&
                formData.custom_vehichle_images_field_post.length == 0
            ) {
                this.toastr.warning("Please Add Images Field");
                return;
            }
            // if (formData.document_images_field_post.length == 0) {
            //     this.toastr.warning("Please Add document Field");
            //     return;
            // }
            delete formData.form_field;
            delete formData.form_video_label;
            formData.inspection_id = this.EditForm.inspection_id;
            formData.sop_id = this.EditForm.sop_id;
            const formDatavalue = new FormData();
            Object.keys(formData).map((value) => {
                if (value !== "video_file") {
                    if (Array.isArray(formData[value])) {
                        formDatavalue.append(
                            value,
                            JSON.stringify(formData[value])
                        );
                    } else {
                        formDatavalue.append(value, formData[value]);
                    }
                } else {
                    formDatavalue.append(
                        value,
                        this.productForm.get("video_file").value
                    );
                }
            });

            this.constant.showLoader();

            this.SOPService.SaveSurveyDetails(formDatavalue).subscribe(
                (data) => {
                    if (data.success == true) {
                        this.toastr.success(data.message, "Success");
                        Swal.fire({
                            title: "Success!",
                            icon: "success",
                            text: "Your Images & Documents submitted successfully, please close this tab now.",
                            allowOutsideClick: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                        }).then(
                            function () { }
                            // handling the promise rejection
                        );
                    } else {
                        this.toastr.warning(data.message);
                    }
                    this.constant.hideLoader();
                },
                (error) => {
                    if (error.status == 401) {
                        this.router.navigate(["/login"]);
                    } else {
                        this.toastr.warning(error.error.message, "Oops");
                    }
                    this.constant.hideLoader();
                }
            );
        }
    }

    compressRatio(size) {
        console.log(size);
        let ratio = 100;
        if (size > 1000) return 50;
        if (size > 800) return 60;
        if (size > 600) return 70;
        if (size > 400) return 80;
        return ratio;
    }
    GetImageDocumentDetails(id) {
        this.constant.showLoader();

        this.SOPService.GetSurveyDetails(id).subscribe(
            (data) => {
                this.constant.hideLoader();
                this.EditForm = data.result;
                this.isVideoActive = this.EditForm.can_record_video;
                this.isSurveyChecklistRestricted =
                    this.EditForm.restrict_surveyChecklist ? true : false;
                this.isDocChecklistRestricted =
                    this.EditForm.restrict_docChecklist ? true : false;
                this.getLocation(this.EditForm.is_location_allowed);
                this.capture =
                    this.EditForm.upload_type == 2 ? "environment" : false;
                this.SOPName =
                    this.EditForm.insured_name +
                    " " +
                    this.EditForm.vehicle_reg_no;
                let vehichle_images_field_label = JSON.parse(
                    data.result.vehichle_images_field_label
                );
                let document_image_field_label = JSON.parse(
                    data.result.document_image_field_label
                );
                console.log(document_image_field_label);

                if (this.isSurveyChecklistRestricted) {
                    vehichle_images_field_label.map(
                        function (value) {
                            this.addFormField(
                                value.path,
                                value.name,
                                false
                            );
                        }.bind(this)
                    );
                }
                if (document_image_field_label && this.isDocChecklistRestricted) {
                    document_image_field_label.map(
                        function (value) {
                            this.addDocumentField(
                                value.path,
                                value.name,
                                false
                            );
                        }.bind(this)
                    );
                }
                if (data.result.custom_vehichle_images_field_label) {
                    let custom_vehichle_images_field_label = JSON.parse(
                        data.result.custom_vehichle_images_field_label
                    );
                    custom_vehichle_images_field_label.map(
                        function (value) {
                            this.addFormField(
                                value.path,
                                value.name,
                                true
                            );
                        }.bind(this)
                    );
                }
                if (data.result.custom_document_image_field_label) {
                    let custom_document_image_field_label = JSON.parse(
                        data.result.custom_document_image_field_label
                    );
                    custom_document_image_field_label.map(
                        function (value) {
                            this.addDocumentField(
                                value.path,
                                value.name,
                                true
                            );
                        }.bind(this)
                    );
                }
            },
            (error) => {
                console.log(error);
                if (error.status == 401) {
                    this.router.navigate(["/login"]);
                } else if (error.status == 422) {
                    Swal.fire({
                        title: "Oops!",
                        icon: "error",
                        text: error.error.message,
                        allowOutsideClick: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then(
                        function () { }
                        // handling the promise rejection
                    );
                }
                this.constant.hideLoader();
            }
        );
    }
    //Gallery.show()
    GalleryList(section, path, index) {
        if (path == "assets/img/no-image.jpg") return false;
        this.FilterImageArray = [];
        this.ImageArray.map((val, i) => {
            if (
                val[section] &&
                val[section]["src"] != "assets/img/no-image.jpg"
            ) {
                this.FilterImageArray.push(val[section]);
            } else if (
                val[section] &&
                val[section]["src"] == "assets/img/no-image.jpg"
            ) {
            }
        });
        console.log(this.FilterImageArray, index);
        if (this.FilterImageArray.length > 0) {
            //  this.Gallery.show();
            this._lightbox.open(this.FilterImageArray, index);
        }
    }

    MenuSelectionManagement(id) {
        $(".nav-item .nav-link").removeClass("SideBarActiveMenu");
        $("#" + id).addClass("SideBarActiveMenu");
    }

    open(index: number): void {
        // open lightbox
        this._lightbox.open(this._album, index);
    }

    close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }

    getLocation(flag: boolean) {
        if (flag) {
            console.log(navigator.geolocation);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.LatLongData = position;
                    },
                    function () {
                        Swal.fire({
                            title: "Oops!",
                            icon: "error",
                            text: "Please unblock location for this website to go further",
                            allowOutsideClick: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                        }).then(
                            function () { }
                            // handling the promise rejection
                        );
                    }
                );
            }
        }
    }
}
